import React, { useEffect, useState } from 'react';
import GlobalSearchTabs from '../../search/common/GlobalSearchTabs';
import { internalAxios } from '../../../utils/axios/internal';
import BackToTopButton from '../../common/BackToTopButton';
import { queryStringToObject } from '../../../utils/http';
import Pagination from '../../common/Pagination';
import A18n from '../../common/A18n';
import './stylesheet.scss';

const Reports = () => {
  const urlParams = queryStringToObject(window.location.search);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (urlParams.keyword) {
      setLoading(true);

      internalAxios
        .get('/api/es/reports/search', {
          params: {
            keyword: urlParams.keyword,
            page,
            t: 1,
          },
        })
        .then(result => {
          setLoading(false);
          setData(result.data.items);
          setTotalCount(result.data.total_count);
        });
    }
  }, [page, urlParams.keyword]);

  return (
    <div className="reports-list">
      <div className="container">
        <h1>
          <A18n rsx="lots.search.m6" />
        </h1>
        <GlobalSearchTabs activeTab={2} />
        {data.map(item => (
          <div key={item.title} className="report">
            <div className="report-img">
              <a href={`/artmarketinsight/${item.page_slug_root}/${item.page_slug}`} target="_blank" rel="noopener noreferrer">
                <img src={item.thumbnail} alt="" />
              </a>
            </div>
            <div className="report-data">
              {/* eslint-disable-next-line react/no-danger */}
              <div className="report-title" dangerouslySetInnerHTML={{ __html: `<a href="/artmarketinsight/${item.page_slug_root}/${item.page_slug}" target="_blank" rel="noopener noreferrer">${item.page_title}</a>` }} />
              <div className="report-highlights">
                {item.highlights.map(highlight => (
                  // eslint-disable-next-line react/no-danger
                  <p key={highlight} dangerouslySetInnerHTML={{ __html: highlight }} />
                ))}
              </div>
            </div>
          </div>
        ))}
        <Pagination totalCount={totalCount} perPage={10} onClick={p => setPage(p)} activePage={page} loading={loading} />
      </div>
      <div className="back-to-top-container">
        <BackToTopButton top="artp-Header-bottom" bottom="bottom-bar" forceHandleResize={loading} />
      </div>
    </div>
  );
};
export default Reports;
